export const apiUrl = require('./apifolder/apiUrl');
export const curUrl = apiUrl[process.env.VUE_APP_MODE];

